import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';

export default function SectionWrapper({ title, onDownload, defaultOpen = true, children }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-app-border rounded-lg bg-app-surface mb-6 overflow-hidden shadow-sm">
      <div 
        className={`flex justify-between items-center p-4 bg-app-surface cursor-pointer select-none ${isOpen ? 'border-b border-app-border' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-3">
          <div className="text-app-muted">{isOpen ? <FiIcons.FiChevronDown /> : <FiIcons.FiChevronRight />}</div>
          <h2 className="text-lg font-semibold text-app-text">{title}</h2>
        </div>
        <div className="flex items-center gap-2" onClick={e => e.stopPropagation()}>
          <button 
            onClick={onDownload} 
            className="flex items-center gap-2 text-xs font-medium bg-app-bg border border-app-border px-3 py-1.5 rounded hover:border-app-accent transition-colors"
          >
            <FiIcons.FiDownload /> Download PDF
          </button>
        </div>
      </div>
      {isOpen && (
        <div className="p-5 bg-app-bg/30">
          {children}
        </div>
      )}
    </div>
  );
}